__turbopack_context__.v({
  "accordion": "cL4Qqa_accordion",
  "chevron": "cL4Qqa_chevron",
  "collapsed": "cL4Qqa_collapsed",
  "container": "cL4Qqa_container",
  "contentContainer": "cL4Qqa_contentContainer",
  "expanded": "cL4Qqa_expanded",
  "groupAction": "cL4Qqa_groupAction",
  "header": "cL4Qqa_header",
  "headerAndChevron": "cL4Qqa_headerAndChevron",
  "item": "cL4Qqa_item",
  "transition": "cL4Qqa_transition",
});
